
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.305 3.45l4.95 4.949-14.02 14.02-5.37.49.42-5.44 14.02-14.02zm0 2.828L3.222 18.36l-.18 2.342 2.29-.21L17.425 8.4l-2.12-2.121zM18.135.62l4.95 4.95-1.416 1.415-4.95-4.95L18.134.62z"}})])
          )
        }
      }
    